function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { ListingBadges } from '@domain-group/fe-allhomes-library';
import { EventBoundary, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import AllhomesBreadcrumbs from '@domain-group/fe-co-allhomes-breadcrumbs';
import { AllhomesKeyDetailsGraphQL } from '@domain-group/fe-co-allhomes-key-details';
import { AllhomesListingSummaryGraphQL } from '@domain-group/fe-co-allhomes-listing-summary';
import { AllhomesListingSuburbStatsGraphQL } from '@domain-group/fe-co-allhomes-listing-suburb-stats';
import { AllhomesListingMapGraphQL } from '@domain-group/fe-co-allhomes-listing-map';
import { AllhomesListingBadges } from '@domain-group/fe-co-allhomes-listing-badges';
import AllhomesListingPhotoCarousel from '@domain-group/fe-co-allhomes-listing-photo-carousel';
import StickyMobile from '@domain-group/fe-co-allhomes-sticky-footer';
import { PropertyHistoryGraphQL } from '@domain-group/fe-co-allhomes-property-history';
import NearbySales from '@domain-group/fe-co-allhomes-nearby-sales';
import { offMarketPropertyWrapper } from '../wrappers';
import ListingDetailsCommonProps, { ListingDetailsDefaultValues } from '../props/common-props';
import useSendPageView from '../analytics/use-send-page-view';
import StickySidebox from '../components/sticky-sidebox';
import { Inner, InnerLeft, InnerRight, Section, HeroImages, Clear, Bottom } from '../components/structure';
import { OffMarketSidebox, OffMarketMobileCTA } from '../components/off-market-find-an-agent-cta';
import { OffMarketAdvice } from '../components/editorial';
import AllhomesListingWhatsNearbyGraphQL from '../components/what-is-nearby/allhomes-listing-whats-nearby-graphql';
import ListingPhotoPreview from '../components/allhomes-listing-hero-photo-preview';
import FollowedProperty from '../components/followed-property';
import { NbnCardGraphQL } from '../components/nbn-card';
import * as styles from './off-market.style';
import * as sharedStyles from './on-market.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var BaseOffMarketListingDetails = props => {
  var _property$address$coo, _property$listing, _property$listing$med, _props$listingVisibil;
  useSendPageView();
  var sidebarBottomRef = useRef();
  var enquiryFormStart = useRef();
  var property = props.property,
    media = props.media;
  var mobile = media.mobile,
    tablet = media.tablet,
    desktop = media.desktop;
  var suburbStats = ___EmotionJSX(AllhomesListingSuburbStatsGraphQL, {
    property: property,
    onSuburbInfoClick: props.onSuburbInfoClick,
    onSummaryTabClick: props.onSummaryTabClick,
    onMedianSalesTabClick: props.onMedianSalesTabClick,
    onViewMoreInfoClick: props.onViewMoreInfoClick,
    onUVClick: props.onUVClick,
    disableAnimation: props.disableAnimation,
    layout: mobile ? 'mobile' : 'tabbed'
  });
  var searchUri = "".concat(props.agencySearchResultsUri).concat(property.address.division.slug, "/");
  return ___EmotionJSX(Fragment, null, mobile && ___EmotionJSX(Fragment, null, ___EmotionJSX(StickyMobile, {
    limitRef: enquiryFormStart
  }, ___EmotionJSX(OffMarketMobileCTA, {
    divisionName: property.address.division.name,
    searchUri: searchUri
  })), ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs
  })), ___EmotionJSX(HeroImages, null, ___EmotionJSX(ListingPhotoPreview, _extends({
    isOffMarket: true,
    staticMapUrl: (_property$address$coo = property.address.coordinates) === null || _property$address$coo === void 0 ? void 0 : _property$address$coo.offMarketMapUrl
  }, props)), props.carouselOpen && !isEmpty((_property$listing = property.listing) === null || _property$listing === void 0 ? void 0 : (_property$listing$med = _property$listing.media) === null || _property$listing$med === void 0 ? void 0 : _property$listing$med.items) && ___EmotionJSX(EventBoundary, {
    name: "listing"
  }, ___EmotionJSX(AllhomesListingPhotoCarousel, {
    fullscreenOnOpen: mobile,
    items: props.items,
    initialIndex: props.initialIndex,
    onSlideChange: props.onSlideChange,
    onSlideClick: props.onSlideClick,
    onSlideLeft: props.onSlideLeft,
    onSlideRight: props.onSlideRight,
    onClose: props.onClose
  })), props.historyGalleryOpen && ___EmotionJSX(EventBoundary, {
    name: "history"
  }, ___EmotionJSX(AllhomesListingPhotoCarousel, _extends({}, props.historyGalleryProps, {
    fullscreenOnOpen: mobile,
    onSlideChange: props.onPropertyHistoryGalleryChange,
    onSlideLeft: props.onPropertyHistoryGalleryLeft,
    onSlideRight: props.onPropertyHistoryGalleryRight,
    onSlideClick: props.onPropertyHistoryGalleryClick
  })))), ___EmotionJSX(Inner, null, tablet && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs
  }), ___EmotionJSX(InnerLeft, null, desktop && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs
  }), ___EmotionJSX(AllhomesListingBadges, {
    annotations: [{
      badge: ListingBadges.offMarket.name,
      label: ListingBadges.offMarket.label,
      shortLabel: ListingBadges.offMarket.label,
      tinyLabel: ListingBadges.offMarket.label
    }]
  }), ___EmotionJSX(AllhomesListingSummaryGraphQL, {
    property: property,
    disableWatchlistButton: true
  }, ___EmotionJSX(NbnCardGraphQL, {
    property: property
  })), property.address.nearbySales && ___EmotionJSX(Section, null, ___EmotionJSX(NearbySales, {
    layout: desktop ? 'horizontal' : 'vertical',
    signedIn: true,
    listingVisibility: (_props$listingVisibil = props.listingVisibility) === null || _props$listingVisibil === void 0 ? void 0 : _props$listingVisibil.sale,
    nearbySales: property.address.nearbySales
  })), ___EmotionJSX(Section, null, ___EmotionJSX(FollowedProperty, {
    addressId: property.address.id,
    followedPropertiesUrl: props.followedPropertiesUrl
  })), ___EmotionJSX(OffMarketAdvice, {
    adviceUrl: props.offMarketAdviceLink
  }), ___EmotionJSX(Clear, null), ___EmotionJSX(Section, {
    className: "allhomes-listing__property-history-section"
  }, ___EmotionJSX(PropertyHistoryGraphQL, {
    property: property,
    onPhotoClick: props.openHistoryGallery,
    onSwipeLeft: props.onPropertyHistorySwipeLeft,
    onSwipeRight: props.onPropertyHistorySwipeRight,
    onTapLeftChevron: props.onPropertyHistoryTapLeft,
    onTapRightChevron: props.onPropertyHistoryTapRight,
    onExpand: props.onPropertyHistoryExpand,
    onCollapse: props.onPropertyHistoryCollapse,
    showOnboarding: false
  })), (tablet || desktop) && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesKeyDetailsGraphQL, {
    property: property
  }))), (tablet || desktop) && ___EmotionJSX(InnerRight, null, ___EmotionJSX(StickySidebox, {
    sidebarBottom: sidebarBottomRef
  }, ___EmotionJSX("div", {
    css: styles.sideboxFrame
  }, ___EmotionJSX(OffMarketSidebox, {
    divisionName: property.address.division.name,
    divisionSlug: property.address.division.slug,
    searchUri: searchUri
  })))), ___EmotionJSX(Clear, {
    border: mobile && !isEmpty(property.address.coordinates)
  }), ___EmotionJSX("div", {
    ref: sidebarBottomRef,
    css: styles.sideboxRef
  }), !isEmpty(property.address.coordinates) && ___EmotionJSX(Section, {
    borderless: mobile
  }, ___EmotionJSX(AllhomesListingMapGraphQL, _extends({
    property: property,
    onMapFirstInteraction: props.onMapFirstInteraction
  }, props))), mobile && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesKeyDetailsGraphQL, {
    property: property
  })), mobile && ___EmotionJSX(Section, null, suburbStats), !isEmpty(property.address.nearbyPOIs) && ___EmotionJSX(Fragment, null, ___EmotionJSX(Clear, null), ___EmotionJSX(Section, {
    fullWidth: true,
    borderless: mobile
  }, ___EmotionJSX(AllhomesListingWhatsNearbyGraphQL, {
    property: property,
    columns: desktop ? 3 : 2
  }))), ___EmotionJSX(Bottom, null, (tablet || desktop) && ___EmotionJSX(Section, {
    fullWidth: true
  }, suburbStats))), ___EmotionJSX("div", {
    ref: enquiryFormStart
  }));
};
BaseOffMarketListingDetails.propTypes = _objectSpread(_objectSpread({}, ListingDetailsCommonProps), {}, {
  stickyBoxOffset: PropTypes.number,
  agencySearchResultsUri: PropTypes.string.isRequired
});
BaseOffMarketListingDetails.defaultProps = _objectSpread({}, ListingDetailsDefaultValues);
export default offMarketPropertyWrapper(withEventBoundary('off-market')(BaseOffMarketListingDetails));
export { BaseOffMarketListingDetails };